import script from "./Blockchains.vue?vue&type=script&setup=true&lang=js"
export * from "./Blockchains.vue?vue&type=script&setup=true&lang=js"

import "./Blockchains.vue?vue&type=style&index=0&id=5eb81372&scoped=true&lang=css"

import exportComponent from "/home/jon/Work/ldpos-wallet/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb81372"]])

export default __exports__